import { useMutation } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import {
  getApplicationTransitionMetadata,
  TransitionMetadataPayload,
} from '../../requests/getApplicationTransitionMetadata';

export const useApplicationTransitionMetadata = (
  definitionName: string,
  workflowName: string,
) => {
  const { constructGet } = useRequestConstructor();

  const { mutateAsync: fetchTransitionMetadata, ...rest } = useMutation({
    mutationFn: ({
      uuid,
      data,
    }: {
      uuid: string;
      data: TransitionMetadataPayload;
    }) =>
      getApplicationTransitionMetadata(
        constructGet,
        uuid,
        definitionName,
        workflowName,
        data,
      ),
  });

  return { fetchTransitionMetadata, ...rest };
};
